import { ID, LinkOptions } from '@griply/types';

export type GoalTreeLink = { id: ID; type: LinkOptions } | null;

// GoalTreeContextMenu hands back the picked path; its last goal entry wins, else the life area.
export const resolveGoalTreeLink = (
  parentIds: ID[],
  lifeAreaId: ID | null,
): GoalTreeLink => {
  const goalId = parentIds[parentIds.length - 1];
  if (goalId) {
    return { id: goalId, type: LinkOptions.Goal };
  }
  if (lifeAreaId) {
    return { id: lifeAreaId, type: LinkOptions.LifeArea };
  }
  return null;
};
